<p-confirmDialog key="idpmainconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="idpmain" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="ItemBorder">
	<!--Heading-->
	<div style="margin-bottom: 15px">
		<h4 style="text-align: center">Identity Providers:</h4>
	</div>

	<!--Table-->
	<div>
		<!--Menu Bar-->
		<div style="background-color: #ffffff">
			<!--Buttons-->
			<div class="button-body flex">
				<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add IDP</button>
				<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit IDP</button>
				<button class="btn btn-warning" style="margin-left: 5px" (click)="onToggle()">{{ ToggleText }}</button>
				<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete IDP</button>
			</div>
		</div>

		<!--Table-->
		<div class="table-main-body">
			<p-table
				#mydt
				[value]="lstIdentityProvider"
				[loading]="IsLoading() == true"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedIdentityProvider"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				dataKey="IdentityProviderID"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Filter or Select from Dropdown-->
					<tr>
						<!--INSERT CUSTOM FILTERS HERE-->

						<!--IdentityProviderDesc-->
						<th>
							<p-columnFilter type="text" field="IdentityProviderDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--LoginButtonDesc-->
						<th>
							<p-columnFilter type="text" field="LoginButtonDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--LoginButtonLink-->
						<th>
							<p-columnFilter type="text" field="LoginButtonLink" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--LogoutButtonLink-->
						<th>
							<p-columnFilter type="text" field="LogoutButtonLink" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--ActiveDesc-->
						<th>
							<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterActiveDesc
										[ngModel]="value"
										[options]="lstActiveDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>
					</tr>

					<!--Column Names-->
					<tr style="height: 4rem">
						<!--INSERT CUSTOM COLUMNS HERE-->
						<th pSortableColumn="IdentityProviderDesc">Provider Name<p-sortIcon field="IdentityProviderDesc"></p-sortIcon></th>
						<th pSortableColumn="LoginButtonDesc">Login Button<p-sortIcon field="LoginButtonDesc"></p-sortIcon></th>
						<th pSortableColumn="LoginButtonLink">Login Link<p-sortIcon field="LoginButtonLink"></p-sortIcon></th>
						<th pSortableColumn="LogoutButtonLink">Logout Link<p-sortIcon field="LogoutButtonLink"></p-sortIcon></th>
						<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-IdentityProvider>
					<tr [pSelectableRow]="IdentityProvider" (dblclick)="onRowDblClick(IdentityProvider)">
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ IdentityProvider.IdentityProviderDesc }}
						</td>

						<td>
							<button
								class="btn btn-primary MaxButtonWidth SSOHover"
								[style.Background]="IdentityProvider.LoginButtonBackground"
								[style.Border-Color]="IdentityProvider.LoginButtonBackground"
								[style.Border-Color]="IdentityProvider.LoginButtonBackground == '#ffffff' ? '#000000' : IdentityProvider.LoginButtonBackground"
								[style.color]="IdentityProvider.LoginButtonForeground"
								[style.padding]="IdentityProvider.HasIcon == true ? '0px' : '6px 12px'"
								(click)="onRowDblClick(IdentityProvider)"
							>
								<img class="SSOButtonIcon" *ngIf="IdentityProvider.HasIcon == true" [src]="IdentityProvider.LoginButtonIconLink" />
								{{ IdentityProvider.LoginButtonDesc }}
							</button>
						</td>

						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ IdentityProvider.LoginButtonLink }}
						</td>

						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ IdentityProvider.LogoutButtonLink }}
						</td>

						<td
							style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
							[style.color]="IdentityProvider.Active == true ? 'Black' : 'Red'"
						>
							{{ IdentityProvider.ActiveDesc }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!--Error Message-->
		<div class="TopMargin">
			<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
		</div>
	</div>
</div>
